import { Info } from "@phosphor-icons/react";
import { useSettings } from "@/lib/settings";

export function PricingNote({ className = "" }) {
  const settings = useSettings();
  const text = settings?.pricing_disclaimer_short
    || "Prices displayed are indicative estimates only. A final quotation will be provided after reviewing your requirements, selected country, and project scope.";
  return (
    <div data-testid="pricing-note" className={`flex items-start gap-3 bg-gos-subtle border border-gos-border rounded-sm p-4 ${className}`}>
      <Info size={18} weight="duotone" className="text-gos-sand mt-0.5 shrink-0" />
      <p className="text-sm text-gos-slate leading-relaxed">{text}</p>
    </div>
  );
}

export default function PricingDisclaimer({ compact = false }) {
  const settings = useSettings();
  const longText = settings?.pricing_disclaimer_long
    || "All costs displayed on this website are indicative estimates provided for planning purposes only. Actual fees may vary depending on country, business structure, government charges, licensing requirements, banking requirements, professional fees, translation costs, compliance obligations, and project complexity. A customized quotation will be provided after assessment of your specific requirements.";
  return (
    <section data-testid="pricing-disclaimer" className="border border-gos-border rounded-sm bg-white p-6 lg:p-8">
      <div className="overline mb-3">Pricing disclaimer</div>
      <h3 className="font-display text-2xl text-gos-charcoal mb-4">All prices are indicative estimates.</h3>
      <p className="text-sm text-gos-slate leading-relaxed">{longText}</p>
      {!compact && (
        <p className="text-sm text-gos-charcoal leading-relaxed mt-5 font-medium">
          For an accurate proposal, please complete the assessment form or schedule a consultation with our team.
        </p>
      )}
    </section>
  );
}
